var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPorterBrookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.501,
    height: 55.353,
    viewBox: "0 0 52.501 55.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4664",
    "data-name": "Rectangle 4664",
    width: 52.501,
    height: 55.353,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28883",
    "data-name": "Group 28883",
    transform: "translate(-1850 -195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28882",
    "data-name": "Group 28882",
    transform: "translate(1850 195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28881",
    "data-name": "Group 28881",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140189",
    "data-name": "Path 140189",
    d: "M13.589,30.177a1.582,1.582,0,0,1,1.582-1.582h1.6V30.22A1.585,1.585,0,0,1,15.186,31.8h-1.6Zm1.581,12.5H13.589V39.959h1.584a9.573,9.573,0,0,0,8.015-4.283,15.125,15.125,0,0,1-1.015-4.856,7.021,7.021,0,0,1-7,6.419H13.589V34.521h1.593a4.305,4.305,0,0,0,4.306-4.3l0-15.217h-4.3A15.192,15.192,0,0,0,0,30.192C0,34.071.017,51.064.028,57.9l2.729,0c-.012-8.557-.038-27.711-.038-27.711a12.47,12.47,0,0,1,12.469-12.47h1.586l0,2.719H15.183a9.747,9.747,0,0,0-9.747,9.748l0,27.711,2.716,0V30.182a7.025,7.025,0,0,1,7.027-7.025h1.588v2.717H15.176a4.3,4.3,0,0,0-4.3,4.3L10.886,45.4h4.279A15.125,15.125,0,0,0,26.3,40.586a15.181,15.181,0,0,1-1.733-2.2,12.428,12.428,0,0,1-9.4,4.3",
    transform: "translate(0 -2.547)",
    fill: "#00306b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140190",
    "data-name": "Path 140190",
    d: "M32.978,34.039A12.392,12.392,0,0,1,31.63,39.12a12.455,12.455,0,0,0,1.724,2.513,14.629,14.629,0,0,0,1.331-2.686,9.7,9.7,0,0,1-1.707-4.908",
    transform: "translate(-5.37 -5.779)",
    fill: "#00306b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140191",
    "data-name": "Path 140191",
    d: "M40.256,26h1.6a1.583,1.583,0,0,1,1.582,1.583v1.626h-1.6a1.583,1.583,0,0,1-1.584-1.582Zm16.769,1.6A15.191,15.191,0,0,0,41.832,12.409h-4.3l.006,15.215a4.306,4.306,0,0,0,4.3,4.3h1.593v2.719H41.848a7.025,7.025,0,0,1-7.026-7.025L34.848,0H32.118L32.1,27.618c0,.218.018.429.032.643a9.736,9.736,0,0,0,9.717,9.107h1.584v2.721l-1.578,0A12.488,12.488,0,0,1,29.387,27.657c.046-25.1.039-25.1.039-27.657H26.668V27.613c0,.223.023.439.032.659a15.125,15.125,0,0,0,2.4,7.564A15.265,15.265,0,0,0,41.86,42.8h4.279l.014-15.218a4.3,4.3,0,0,0-4.3-4.3H40.256V20.565h1.59a7.027,7.027,0,0,1,7.027,7.025l0,15.221,2.717-2.417v-12.8a9.748,9.748,0,0,0-9.749-9.747H40.254l0-2.72h1.585A12.47,12.47,0,0,1,54.305,27.6s0,1.82,0,10.379l2.722-2.463c.011-6.834,0-4.034,0-7.915",
    transform: "translate(-4.527 0)",
    fill: "#00306b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterBrookLogo);
export default __webpack_public_path__ + "static/media/porter-brook-logo.cb4f4520878462935a4c3f13d5028cf6.svg";
export { ForwardRef as ReactComponent };